import React from "react";
import styles from "./styles.module.scss";
import Pagination from "../../../components/Pagination/Pagination";
import Table from './table';

const List = ({
  loading,
  data,
  setPage,
  getEMSOffices,
  page,
  pageCount,
  totalItems,
  itemsPerPage
}) => {
  const handlePage = (pageValue) => {
    setPage(pageValue.selected + 1);
  };

  return (
    <div className={styles.card}>
      <div>
        <Table
          loading={loading}
          data={data}
          fetchData={getEMSOffices}
        />
        {!loading && data?.length > 0 && (
          <div className={styles.pagination}>
            <Pagination
              pageCount={pageCount}
              currentPage={page - 1}
              onPageChange={handlePage}
              totalItems={totalItems}
              itemsPerPage={itemsPerPage}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default List;
